module.exports = __webpack_public_path__ + "img/destination-dubai.020cd3a2.jpg";